import api from "./api";
import { BaseResponse, IntegrationResponse } from "../types/responses.type";

class IntegrationService {
  async post(
    endpoint: string,
    query?: Record<string, string>,
    data?: any,
  ): Promise<BaseResponse> {
    try {
      const response = await api.post(`/integrations${endpoint}`, data, {
        params: query,
      });
      return response.data;
    } catch (error: any) {
      if (error.response) {
        return error.response.data;
      }
      return {
        ok: false,
        errorMessage: "Failed to post data",
      };
    }
  }
  async get(
    endpoint: string,
    query: Record<string, string>,
  ): Promise<BaseResponse> {
    try {
      const response = await api.get(`/integrations${endpoint}`, {
        params: query,
      });
      return response.data;
    } catch (error: any) {
      if (error.response) {
        return error.response.data;
      }
      return {
        ok: false,
        errorMessage: "Failed to handle integration callback",
      };
    }
  }
  async start(integrationName: string): Promise<BaseResponse> {
    try {
      const response = await api.get(`/integrations/${integrationName}/start`);
      if (response.data.ok) {
        if (response.data.data?.type == "redirect") {
          window.location.href = response.data.data?.redirectUrl;
        }
      }
      return { ok: false };
    } catch (error: any) {
      if (error.response) {
        return error.response.data;
      }
      return {
        ok: false,
        errorMessage: "Failed to handle integration callback",
      };
    }
  }
  async disconnect(integrationName: string): Promise<BaseResponse> {
    try {
      const response = await api.get(
        `/integrations/${integrationName}/disconnect`,
      );
      if (response.data.ok) {
        if (response.data.data?.type == "refresh") {
          window.location.reload();
        }
      }
      return { ok: false };
    } catch (error: any) {
      if (error.response) {
        return error.response.data;
      }
      return {
        ok: false,
        errorMessage: "Failed to handle integration callback",
      };
    }
  }
  async getConnected(): Promise<IntegrationResponse[]> {
    const response = await api.get(`/integrations/connected`);
    return response.data?.data;
  }
  async getConnectable(): Promise<IntegrationResponse[]> {
    const response = await api.get(`/integrations?connectable`);
    return response.data?.data;
  }
}

export default new IntegrationService();
